import {
    GET_ADMIN_MENU_TYPE_REQUEST,
    GET_ADMIN_MENU_TYPE_ERROR,
    GET_ADMIN_MENU_TYPE_SUCCESS,
    ADD_ADMIN_MENU_TYPE_REQUEST,
    ADD_ADMIN_MENU_TYPE_ERROR,
    ADD_ADMIN_MENU_TYPE_SUCCESS,
    UPDATE_ADMIN_MENU_TYPE_REQUEST,
    UPDATE_ADMIN_MENU_TYPE_ERROR,
    UPDATE_ADMIN_MENU_TYPE_SUCCESS,
    DELETE_ADMIN_MENU_TYPE_REQUEST,
    DELETE_ADMIN_MENU_TYPE_ERROR,
    DELETE_ADMIN_MENU_TYPE_SUCCESS,
} from "./types";

import { BASEURL } from "../../constant/config.js";

const axios = require("axios");

export const getAdminMenuType = (token, menu_id) => (dispatch) => {
    dispatch({ type: GET_ADMIN_MENU_TYPE_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/admin_menu_type`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { menu_id }
    })
        .then((response) => {
            return dispatch({ type: GET_ADMIN_MENU_TYPE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_ADMIN_MENU_TYPE_ERROR,
                payload: error.response,
            });
        });
};

export const addAdminMenuType = (token, data, menu_id) => (dispatch) => {



    dispatch({ type: ADD_ADMIN_MENU_TYPE_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/admin_menu_type`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { menu_type_name: data.adminMenuTypeName, is_active: data.check, menu_id },
    })
        .then((response) => {

            return dispatch({ type: ADD_ADMIN_MENU_TYPE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_ADMIN_MENU_TYPE_ERROR,
                payload: error.response,
            });
        });
};

export const updateAdminMenuType = (token, data, id) => (dispatch) => {
    dispatch({ type: UPDATE_ADMIN_MENU_TYPE_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/admin_menu_type/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { menu_type_name: data.adminMenuTypeName, is_active: data.check },
    })
        .then((response) => {

            return dispatch({ type: UPDATE_ADMIN_MENU_TYPE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_ADMIN_MENU_TYPE_ERROR,
                payload: error.response,
            });
        });
};

export const deleteAdminMenuType = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_ADMIN_MENU_TYPE_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/admin_menu_type/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {

            return dispatch({ type: DELETE_ADMIN_MENU_TYPE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_ADMIN_MENU_TYPE_ERROR,
                payload: error.response,
            });
        });
};
